// External
import React from 'react';
import { func, string } from 'prop-types';
import { useTokens } from '@nike/nike-design-system-components';

// Internal
import { catalogTypeType } from './propTypes';

import BadgeStyled from '../../components/BadgeStyled';

const CatalogTypeBadge = ({ catalogType, disassociateCatalogType, width }) => {
  const tokens = useTokens();
  return (
    <BadgeStyled
      text={catalogType?.name}
      onClose={disassociateCatalogType ? () => disassociateCatalogType(catalogType) : null}
      backgroundColor={tokens.podiumCdsColorGrey200}
      width={width}
    />
  );
};

CatalogTypeBadge.defaultProps = {
  disassociateCatalogType: null,
  width: null
};

CatalogTypeBadge.propTypes = {
  disassociateCatalogType: func,
  catalogType: catalogTypeType.isRequired,
  width: string
};

export default CatalogTypeBadge;
